import { SOGetOrganization } from '../organization/so-get-organization';
import { SOGetPrice } from '../price/so-get-price';
import {MMQueryOptions} from 'lionheartland';
import {QueryProtocol} from 'lionheartland';


export class SOGetSubscription implements QueryProtocol {

  constructor(
    public uid: string = null,
    public exRef: string = null,
    public organization: SOGetOrganization = null,
    public price: SOGetPrice = null,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOGetSubscription(
      'uid' in params ? params.uid : null,
      'exRef' in params ? params.exRef : null,
      'organization' in params ? params.organization : null,
      'price' in params ? params.price : null,
      'predicate' in params ? params.predicate : null,
      'queryOptions' in params ? params.queryOptions : new MMQueryOptions(),
    );
  }
}
